import React from 'react';
import PopupClose from '../../../components/popups/Close';

export const ISpringPopup = () => (
  <div className="popup ispring-popup">
    <div className="popup__close-container"><PopupClose/></div>
    <div className="ispring-badge__image ispring-badge__image--popup">new</div>
    <section className="ispring-popup__container">
      <header className="ispring-popup__header">
        Новый раздел «Мое обучение»
      </header>
      <div className="ispring-popup__content">
        Добавили раздел — «Мое обучение», теперь здесь находятся ваши купленные
        курсы. Чтобы вам было проще ориентироваться, добавили материалы,
        прогресс обучения и данные о завершении.
      </div>

      <div className="ispring-preview__container">
        <div className="ispring__container ispring-preview--fix">
          <div className="ispring-content">
            <div className="ispring-info__container ispring-preview__container">
              <div className="ispring-info__header ispring-preview__header" />
              <div className="ispring-info__content">
                <div className="ispring-preview__line" />
                <div className="ispring-preview__line" />
                <div className="ispring-preview__line" />
              </div>
            </div>
            <div className="ispring-hint ispring-preview__hint--margin-fix ">
              <div className="ispring-preview__hint" />
            </div>
          </div>

          <div className="ispring-cta__container">
            <div className="ispring-cta__button ispring-preview__button" />
            <div className="ispring-cta__description ispring-preview__description" />
            <div className="ispring-cta__progress--not-started ispring-preview__progress" />
          </div>
        </div>
      </div>
      <button
        className="btn btn--primary"
        onClick={() => {
          $.magnificPopup.close();
        }}
      >
        Отлично
      </button>
    </section>
  </div>
);
